import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { resetSelectedChat } from 'modules/chats';
import {
  getThinkTank, getThinkTankTools, changeThinkTankImage, requestJoin, acceptJoin, rejectJoin, leaveThinkTank,
} from 'components/ThinkTanks/modules/actions';
import Think from '../components';


function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.session.user,
    literals: state.i18n.literals.thinkTank || {},
    actualThinkTank: state.thinkTanks.actualThinkTank,
    actualThinkTankStatus: state.thinkTanks.actualThinkTankStatus,
    actualThinkTankTools: state.thinkTanks.actualThinkTankTools,
    actualThinkTankToolsStatus: state.thinkTanks.actualThinkTankToolsStatus,
    requestThinkTankError: state.thinkTanks.requestThinkTankError,
    requestThinkTankStatus: state.thinkTanks.requestThinkTankStatus,
    requestsJoinThinkTank: state.thinkTanks.requestsJoinThinkTank,
    requestAcceptThinkTankStatus: state.thinkTanks.requestAcceptThinkTankStatus,
    requestRejectThinkTankStatus: state.thinkTanks.requestRejectThinkTankStatus,
    requestsLeaveThinkTankError: state.thinkTanks.requestsLeaveThinkTankError,
    requestLeaveThinkTankStatus: state.thinkTanks.requestLeaveThinkTankStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getThinkTank: bindActionCreators(getThinkTank, dispatch),
    getThinkTankTools: bindActionCreators(getThinkTankTools, dispatch),
    changeThinkTankImage: bindActionCreators(changeThinkTankImage, dispatch),
    requestJoin: bindActionCreators(requestJoin, dispatch),
    acceptJoin: bindActionCreators(acceptJoin, dispatch),
    rejectJoin: bindActionCreators(rejectJoin, dispatch),
    resetSelectedChat: bindActionCreators(resetSelectedChat, dispatch),
    leaveThinkTank: bindActionCreators(leaveThinkTank, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Think));



// WEBPACK FOOTER //
// ./src/routes/ThinkTank/container/index.js